var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 26,
    viewBox: "0 0 6 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 23C6 23.7956 5.68393 24.5587 5.12132 25.1213C4.55871 25.6839 3.79565 26 3 26C2.20435 26 1.44129 25.6839 0.878679 25.1213C0.31607 24.5587 0 23.7956 0 23C0 22.2044 0.31607 21.4413 0.878679 20.8787C1.44129 20.3161 2.20435 20 3 20C3.79565 20 4.55871 20.3161 5.12132 20.8787C5.68393 21.4413 6 22.2044 6 23ZM6 13C6 13.7956 5.68393 14.5587 5.12132 15.1213C4.55871 15.6839 3.79565 16 3 16C2.20435 16 1.44129 15.6839 0.878679 15.1213C0.31607 14.5587 0 13.7956 0 13C0 12.2044 0.31607 11.4413 0.878679 10.8787C1.44129 10.3161 2.20435 10 3 10C3.79565 10 4.55871 10.3161 5.12132 10.8787C5.68393 11.4413 6 12.2044 6 13ZM6 3C6 3.79565 5.68393 4.55871 5.12132 5.12132C4.55871 5.68393 3.79565 6 3 6C2.20435 6 1.44129 5.68393 0.878679 5.12132C0.31607 4.55871 0 3.79565 0 3C0 2.20435 0.31607 1.44129 0.878679 0.87868C1.44129 0.316071 2.20435 0 3 0C3.79565 0 4.55871 0.316071 5.12132 0.87868C5.68393 1.44129 6 2.20435 6 3Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3c79edb861fb73de2fa0f6a5b489c097.svg";
export { ForwardRef as ReactComponent };